import * as authActions from "@rentiohq/shared-frontend/dist/redux/auth/auth.actions";
import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import { IPartialRootState } from "@rentiohq/shared-frontend/dist/redux/types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { SHOW_CONFIRM_MODAL } from "@rentiohq/web-shared-next/dist/redux/actions";
import {
  Button,
  MainCard,
  Loader,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { enqueueSnackbar } from "@rentiohq/web-shared-next/dist/utils/snackbar";
import { EButtonVariants } from "@rentiohq/web-shared-next/dist/utils/types/button";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

export const More = () => {
  const dispatch = useDispatch();

  const isRemovingProfile = useSelector((state: IPartialRootState) =>
    authSelectors.isRemovingProfile(state),
  );

  const removeProfileError = useSelector((state: IPartialRootState) =>
    authSelectors.removeProfileError(state),
  );
  const handleCloseConfirmModal = () => {
    dispatch({
      type: SHOW_CONFIRM_MODAL,
      payload: { showConfirmModal: false },
    });
  };

  const handleUserDelete = () => {
    dispatch(
      authActions.removeProfile.actions.start({
        onSuccess: () => {
          dispatch({ type: "LOG_OUT" });
          handleCloseConfirmModal();
        },
      }),
    );
  };

  const handleUserDeleteConfirmation = async () => {
    dispatch({
      type: SHOW_CONFIRM_MODAL,
      payload: {
        title: getLocalizedText("account.delete.button"),
        description: getLocalizedText("account.delete.confirm"),
        showConfirmModal: true,
        actions: [
          {
            label: getLocalizedText("system.no"),
            onClick: handleCloseConfirmModal,
            variant: EButtonVariants.Outlined,
          },
          {
            label: getLocalizedText("system.yes"),
            onClick: handleUserDelete,
          },
        ],
      },
    });
  };

  React.useEffect(() => {
    if (removeProfileError) {
      enqueueSnackbar({
        variant: "error",
        message: removeProfileError.message,
      });
    }
  }, [removeProfileError]);

  return (
    <MainCard>
      {isRemovingProfile ? (
        <Loader />
      ) : (
        <Button variant="text" onClick={handleUserDeleteConfirmation}>
          {getLocalizedText("profile.delete.button")}
        </Button>
      )}
    </MainCard>
  );
};
